export default function About() {
  return (
    <section id="about" className="section-py bg-background-50">
      <div className="section-container">
        <div className="max-w-3xl mx-auto">
          <div className="flex items-center justify-center gap-3 mb-8">
            <div className="w-1 h-6 rounded-full bg-primary-500"></div>
            <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950">
              关于我们
            </h2>
          </div>

          <div className="text-center">
            <div className="w-16 h-16 flex items-center justify-center rounded-full bg-primary-50 text-primary-600 mx-auto mb-5">
              <i className="ri-eye-line text-2xl"></i>
            </div>

            <h3 className="text-lg md:text-xl font-bold font-heading text-foreground-900 mb-4">
              51爆料网 — 你的赛事吃瓜第一站
            </h3>

            <div className="text-sm text-foreground-600 leading-relaxed space-y-4 max-w-2xl mx-auto">
              <p>
                51爆料网成立于对赛事资讯的深度洞察之上，我们致力于为广大赛事爱好者和吃瓜群众提供最及时、最全面的每日大赛爆料内容。从电竞赛场到体育看台，从综艺后台到音乐现场，我们覆盖51爆料每日大赛、51吃瓜爆料每日大赛等热门赛事领域，让每一个关注赛事动态的人都能在这里找到感兴趣的爆料内容。
              </p>
              <p>
                我们的内容团队由资深赛事记者、前职业选手和深度吃瓜达人组成，确保每一条爆料都经过多方核实，在追求速度的同时坚守真实底线。51爆料网不是简单的信息搬运工，我们更注重为读者提供独到的赛事解读和幕后故事，让爆料不止于表面。
              </p>
              <p>
                平台每日更新100+条最新爆料，覆盖50+热门赛事类型，累计爆料内容突破10万条。无论你关注的是电竞战队的转会风云，还是体育明星的场外八卦，抑或是综艺节目的幕后揭秘，51爆料网都为你一网打尽。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}